import "@examspark/common-util/setupProcess";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";

import { delay } from "@examspark/common/dist/utils";
import { AppLoading } from "@examspark/common-app/preload";

import * as serviceWorker from "./serviceWorker";

const App = React.lazy(async () => {
  // artifically delay the loading of the app to prevent the loading screen
  // from flashing.
  const [, app] = await Promise.all([delay(1000), import("./App")]);
  return app;
});

// Only responsibility is to lazy-load the rest of the application.
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Suspense fallback={<AppLoading text="Loading Campfire" />}>
    <App />
  </Suspense>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
